import merge from 'lodash/merge'

import { useBuilder } from '@/lib/builder/extension/useBuilder'

import { type CouponSection } from '../../../types'

const funnelBuilderQueue = useBuilder('emailBuilder')

const CouponCommands = {
  updateBlock: funnelBuilderQueue.createBlockCommand<CouponSection>({
    commit: async (currentData, ctx) => {
      return merge(currentData, ctx.update)
    },
  }),
}

export { CouponCommands }
